<template>
    <div>
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">其他支出</div>
                        </el-col>

                    </el-row>
                    <el-row style="text-align: left">
                        <el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData">
                            <el-form-item >
                                <el-date-picker
                v-model="searchForm.month"
                type="month"
                clearable
                value-format="yyyy-MM"
       placeholder="月份">
       </el-date-picker>
                            </el-form-item>
                            <el-form-item >
                                <el-button @click="searchData()">查询</el-button>
                                <el-button  type="primary" v-if="isAuth('outsidegd:add')" @click="addOrUpdate()" >添加</el-button>
                                <el-upload style="display: inline-block;margin: auto 12px;"  size="mini" :on-change="handleChange" :http-request="modeUpload" :auto-upload="false" :multiple="false" ref="upload" :show-file-list="false" action="" :file-list="mode">
                                    <el-button type="success">导入</el-button>
                                </el-upload>
                                <el-button type="success" @click="exportExcel()">导出</el-button>
                            </el-form-item>

                        </el-form>
                    </el-row>
                </div>

                <el-table
                        :header-cell-class-name="handleHeaderClass"
                        @sort-change="handleTableSort"
                        :data="dataList"  v-loading="loading"  style="text-align: center; width: 100%;">
                    <el-table-column prop="month" label="日期" />
                    <el-table-column prop="cbj" label="残保金"  />                     
                    <el-table-column prop="zjjtx" label="折旧及摊销"  />                     
                    <el-table-column prop="lfyp" label="劳防用品"  />                     
                    <el-table-column prop="qtfy" label="其他费用"  />                     
                    <el-table-column label="操作" fixed="right">
                        <template slot="header" slot-scope="scope">
                            <div class="clearfix" style="display:flex">
                    <span>操作</span>
                    </div>
                        </template>
                        <template slot-scope="scope">                           
                            <el-button type="text" size="mini" v-if="isAuth('outsidegd:update')"  @click="addOrUpdate(scope.row.id)">修改</el-button>
                            <el-button type="text" size="mini" v-if="isAuth('outsidegd:delete')" @click="deleteHandle(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>
                <div style="text-align: left;display: none;">
                    <form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/gscb/export?access_token='+this.$store.getters.token" target="_blank">
                        <input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
                        <input type="hidden" name="fileds" value="" ref="fileds"/>
                    </form>
                </div>
                <!-- <el-dialog
                        style="text-align: left;"
                        title="导出"
                        :visible.sync="exportVisible">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
                        <el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
                    </el-checkbox-group>
                    <form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/gscb/export?access_token='+this.$store.getters.token" target="_blank">
                        <input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
                        <input type="hidden" name="fileds" value="" ref="fileds"/>
                    </form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="exportVisible = false">取 消</el-button>
                        <el-button type="primary" @click="exportExcel">确 定</el-button>
                    </span>
                </el-dialog> -->
            </el-card>
        </div>
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="searchData"></add-or-update>
    </div>
</template>
<script>
    import {
        Vue,
        Component
    } from 'vue-property-decorator'
    import AddOrUpdate from './outside-gd-add-or-update'
    const exportFields=[
        {name:'日期',value:'month'},
        {name:'残保金',value:'cbj'},
        {name:'折旧及摊销',value:'zjjtx'},
        {name:'劳防用品',value:'lfyp'},
        {name:'其他费用',value:'qtfy'}
    ]
    @Component({
        name: 'tOutsideGdxx',
        components:{
            AddOrUpdate,
        }
    })
    export default class tOutsideGdxx extends Vue {
        mode = []
        fileList = []
        addOrUpdateVisible=false
        currentNo = 1;
        pageSize = 10;
        pageTotal = 0;
        dataList=[]
        showInfoVisible=false
        searchForm={
           month:''
        }
        loading = false;
        dataListSelections=[];
        depts=[]
        deptdisable=false
        orders=[]
        time=[]
        exportVisible = false;
        outsideSetUserVisible = false;
        outGdUserVisible = false;
        outGdDkVisible = false;
        isIndeterminate= false
        checkAll=false;
        fields=exportFields;
        filedValues=exportFields.map(item => item.value);
        fieldList=[];
        created() {
            this.searchData()
        }
        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }

            }).then(res => {
                that.depts = res.data
                if(this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc){
                        if(zzdyqc != this.CONST_ZN_BM) {
                            var zw = this.$store.getters.user.zw;

                            if(zw) {
                                if(zw=='01'||zw=='02'||zw=='03') {
                                    this.searchForm.bmid = that.depts[0].bmid
                                    this.deptdisable = true

                                }

                            }
                        }

                    }

                }
                this.searchData();
            })
        }
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchData();
        }
        handleCurrentChange(val) {
            this.currentNo = val;
            this.searchData();
        }
        // 多选
        selectionChangeHandle (val) {
            this.dataListSelections = val
        }
        addOrUpdate(val) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(val)
            })
        }
        setUser(val) {
            this.outsideSetUserVisible = true
            this.$nextTick(() => {
                this.$refs.outsideSetUser.init(val)
            })
        }
        showUser(val) {
            this.outGdUserVisible = true
            this.$nextTick(() => {
                this.$refs.outGdUser.init(val)
            })
        }
        dkList(val) {
            this.outGdDkVisible = true
            this.$nextTick(() => {
                this.$refs.outGdDkList.init(val)
            })
        }
        showInfo(val) {
            this.showInfoVisible = true
            this.$nextTick(() => {
                this.$refs.showinfo.init(val)
            })
        }
        deleteHandle (id) {
            this.$confirm(`确定进行[删除]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: '/bjba/gscb/delete/'+id,
                    method: 'get',
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if(data && data.code ==500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }
        changeIndex(){
            this.currentNo =1
        }
        getParams() {
            this.searchForm.page = this.currentNo;
            this.searchForm.pagesize = this.pageSize
        }
        searchData () {
            this.loading = true
            this.getParams()
            this.$request.get('/bjba/gscb/list',{params:this.searchForm}).then(res => {
                const {data} = res
                this.loading = false
                this.dataList = data.data.content
                this.pageTotal = data.data.totalElements
            }).catch(err => {
                this.$message({
                    message: '获取列表出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
            this.loading = false
            console.log(err)
            })
        }

        handleOrderChange (orderColumn, orderState) {
            let result = this.orders.find(e => e.orderColumn === orderColumn)
            if (result) {
                if(orderState)
                    result.orderState = orderState
                else {
                    var j =this.orders.indexOf(result);
                    if(j !== -1) {
                        this.orders.splice(j,1);
                    }
                }
            } else {
                this.orders.push({
                    orderColumn: orderColumn,
                    orderState: orderState
                })
            }
            this.searchData()
        }
// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
        handleTableSort({ column }) {
            column.multiOrder = column.order
            this.handleOrderChange(column.property, column.multiOrder)
        }
        // 设置列的排序为我们自定义的排序
        handleHeaderClass({ column }) {
            if(!column.multiOrder) column.multiOrder =''
            column.order = column.multiOrder
        }
        // renderHeader (h) {
        //     return (
        //             <div class="clearfix">
        //             <span>操作</span>
        //             <el-upload :on-change="handleChange5" :http-request="modeUpload" :auto-upload="false" :multiple="false" ref="upload" :show-file-list="false" action="" :file-list="mode">
        //               <el-button icon="iconfont icon-shangchuan" size="small" type="text">导入</el-button>
        //             </el-upload>
        //             <el-button style="padding:5px;float:right" size="mini"
        //     onClick={()=>this.exportExcel()}>导出</el-button></div>
        //     )
        // }
        modeUpload(item) {
      this.mode = item.file
    }
        showExportDialog() {
            this.exportVisible = true
        }
        handleCheckAllChange(val) {
            this.fieldList = val ? this.filedValues: [];
            this.isIndeterminate = false;
        }
        handleCheckedItemChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.filedValues.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
        }
        handleChange(file,fileList) {
    //   let file = this.$refs.upload.uploadFiles
      this.imports(file)
    }
    imports(file) {
      let data = new FormData()
      data.append('file', file.raw)
     this.axios.post('/bjba/gscb/import', data, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
        this.$refs.upload.clearFiles()
        if (response && response.data.code === 200) {
                                this.$message({
                                    message: '导入成功',
                                    type: 'success',
                                    duration: 3000
                                })
                                this.visible = false
                                this.searchData()
                            } else if(data && response.data.code === 500) {
                                this.$message({
                                    message: data.message,
                                    type: 'error',
                                    duration: 3000
                                })
                            }
      })
    }
        exportExcel() {
            var filedLast = exportFields
            if(filedLast && filedLast.length>0) {
                this.$refs.fileds.value = JSON.stringify(filedLast)
                console.log('cnej:',this.$refs.fileds.value)
                this.$refs.exportForm.submit();
            } else {
                this.$message({
                    message: '请选择字段',
                    type: 'error',
                    duration: 1500
                })
                return
            }

            //
        }
    }
</script>
<style lang="scss" scoped>
    .bcgl {}
</style>
